<template>
  <div class="yszc-container">
    <div class="header">
      <h2 style="text-align: center;">{{ appName }}服务使用协议</h2>
    </div>
    <div class="content">

      <h2>1. 特别提示</h2>
      <p class="W_fb">1.1 {{ appName }}运营方同意按照本协议的规定及其不时发布的操作规则向用户提供{{ appName }}服务。为获得{{ appName }}服务，{{ appName
        }}服务使用人（以下称"用户"）需在认真阅读及独立思考的基础上认可、同意本协议的全部条款（特别是以加粗方式提示用户注意的条款）并按照页面上的提示完成全部的注册程序。用户在进行注册过程中点击"同意"
        按钮（或实际使用{{ appName }}服务）即表示用户完全接受本服务协议、{{ appName }}社区公约、{{ appName }}商业行为规范办法、{{ appName
        }}举报投诉操作细则及{{ appName }}运营方公示的各项规则、规范。如用户对本服务协议或协议的任何部分存有任何异议，应终止注册程序（或停止使用{{ appName }}服务）。
      </p>
      <p class="para W_fb">1.2 用户注册成功后，{{ appName }}运营方将为用户基于使用{{ appName }}服务的客观需要而在申请、注册{{ appName
        }}服务时，按照注册要求提供的账号开通{{ appName }}服务，用户有权在{{ appName }}运营方为其开通并同意向其提供服务的基础上使用{{ appName }}服务。同时，用户同意：
      </p>

      <p class="para W_fb">1.2.1 用户上传的所有视频均由用户全权负责。本工具不识别、不存储、不干预视频内容，处理结果不代表平台立场。</p>
      <p class="para W_fb">1.2.1.1 严格禁止用户将本工具用于以下用途（包括但不限于）：处理涉黄、暴恐、血腥等违法内容，制作侵权、造谣、诈骗等非法素材，规避平台监管从事黑灰产行为</p>
      <p class="para W_fb">1.2.1.2 用户因违反上述条款产生的全部法律责任（如行政处罚、刑事追责、民事赔偿等）由其自行承担，与本平台无关。</p>
      <p class="para W_fb">1.2.1.3 如发现违法使用行为，本平台将：立即终止违规账号服务，依法向监管机构提供数据协查，保留追究损害赔偿责任的权利</p>


      <p class="para W_fb">1.2.2 用户应妥善保管{{ appName }}账号及密码。</p>
      <p class="para W_fb">1.2.3 未经{{ appName }}运营方同意，用户不得擅自买卖、转让、出租任何{{ appName }}账号或{{ appName }}昵称。</p>
      <p class="para W_fb">1.2.4
        用户使用{{ appName }}服务过程中，须对自身使用{{ appName }}服务的行为，对任何由用户通过{{ appName }}服务造成违规违法后果与{{ appName
        }}平台无关，由用户承担全部责任。</p>

      <p class="para W_fb">1.3 用户使用{{ appName }}服务过程中，对自身使用{{ appName }}服务的行为以及通过{{ appName
        }}服务在其他平台发布公开的任何信息和视频，应当承担相应法律责任。
      </p>
      <p class="para W_fb">1.5 在法律法规允许的范围内，用户同意并授权{{ appName
        }}运营方就侵犯用户合法权益的行为（包括但不限于私自复制、使用、编辑、抄袭等行为）采取任何形式的法律行动，包括但不限于投诉、诉讼等必要的维权措施。

      </p>
      <p class="para W_fb">1.7 为提高用户的{{ appName }}服务使用感受和满意度，用户同意{{ appName }}运营方可以对用户数据进行调查研究和分析，从而进一步优化{{ appName
        }}服务。</p>
      <p class="para W_fb" style="font-weight: 600">1.8 虚拟物品费用退款说明:{{ appName
        }}VIP(会员)系网络商品和虚拟商品，采用先收费后服务的方式，会员费用是您所购买的会员服务所对应的网络商品价格，而非预付款或者存款、定价等性质。因此{{ appName
        }}VIP(会员)一旦购买成功后，已表明您已经使用了该商品，成功购买后暂不支付退款
      </p><br>
      <h2>2. 服务内容</h2>
      <p>2.1 {{ appName }}服务的具体内容由{{ appName }}运营方根据实际情况提供。</p>
      <p class="para">2.2 {{ appName }}运营方提供的{{ appName }}服务为收费网络工具服务，用户使用网络工具服务需要向{{ appName
        }}运营方支付一定的费用。对于收费的网络工具服务，{{ appName }}运营方会在用户使用之前给予用户明确的提示，只有用户根据提示确认其愿意支付相关费用，用户才能使用该等收费网络工具服务。如用户拒绝支付相关费用，则{{
          appName }}运营方有权不向用户提供该等收费网络工具服务。
      </p>
      <p class="para">2.3 用户应理解，{{ appName }}运营方仅提供与{{ appName
        }}服务相关的技术服务，如视频处理问题，账户问题等，不涉及平台以外技术服务，也未保证任何承诺与效果，只针对用户提供的视频多样化创作，不涉及任何平台利益，如有违法违规用户应承担相应责任
      </p>

      <h2>3. 服务变更、中断或终止</h2>
      <p class="para">3.1 鉴于网络服务的特殊性（包括但不限于服务器的稳定性问题、恶意的网络攻击等行为的存在及其他{{ appName }}运营方无法控制的情形），用户同意{{ appName
        }}运营方有权随时中断或终止部分或全部的{{ appName }}服务（包括收费网络工具服务），若发生该等情形，{{ appName
        }}运营方将尽可能及时通过网页公告、系统通知、私信、短信提醒或其他合理方式通知受到影响的用户。
      </p>
      <p class="para">3.2 用户理解，{{ appName }}运营方需要定期或不定期地对提供{{ appName
        }}服务的平台（如互联网网站、应用程序等）或相关的设备进行检修或者维护，如因此类情况而造成服务在合理时间内的中断，{{ appName }}运营方无需为此承担任何责任，但{{ appName }}运营方应尽可能事先进行通告。
      </p>
      <p class="para W_fb">3.3 如发生下列任何一种情形，{{ appName }}运营方有权随时中断或终止向用户提供本协议项下的{{ appName
        }}服务（包括收费服务和免费服务）而无需对用户或任何第三方承担任何责任，由此造成的损失由用户自行独立承担：
      </p>
      <p class="para W_fb">3.3.1 用户提供的个人资料不真实；</p>
      <p class="para W_fb">3.3.2 用户违反法律法规国家政策或本协议中规定的使用规则；</p>
      <p class="para W_fb">3.3.3 用户在使用收费服务时未按规定为其所使用的收费服务支付相关服务费用；</p>
      <p class="para W_fb">3.3.4
        用户侵犯个人、企业事业单位或社会团体的合法权益，包括但不限于专利权、著作权、商标权，或姓名权、名称权、名誉权、荣誉权、肖像权、隐私权等；</p>
      <p class="para W_fb">3.3.5 用户损害监管部门、国家机关及政府形象；</p>
      <p class="para W_fb">3.3.6 用户以任何方式损害{{ appName }}运营方及其关联公司的商誉或信誉等合法权益；</p>
      <p class="para W_fb">3.3.7 {{ appName }}运营方有其他合理理由认为需要中断或终止向用户提供{{ appName }}服务的。</p>
      <p class="para W_fb">3.4 如用户在申请开通{{ appName }}服务后在任何连续90日内未实际使用，则{{ appName }}运营方有权在法律法规允许的范围内选择采取以下任何一种方式进行处理：
      </p>
      <p class="para W_fb">3.4.1 回收用户昵称；</p>
      <p class="para W_fb">3.4.2 回收用户账号；</p>
      <p class="para W_fb">3.4.3 停止为该用户提供{{ appName }}服务。</p>
      <p class="para W_fb">3.5 用户选择将{{ appName }}账号与{{ appName
        }}运营方合作的第三方账号进行绑定的，除用户自行解除绑定关系外，如发生下列任何一种情形，用户已绑定的第三方账号也有可能被解除绑定，{{ appName }}运营方无需对用户或任何第三方承担任何责任：</p>
      <p class="para W_fb">3.5.1 用户违反法律法规国家政策、本协议的；</p>
      <p class="para W_fb">3.5.2 用户违反第三方用户协议或其相关规定的；</p>
      <p class="para W_fb">3.5.3 第三方账号所属的站方要求解除绑定的；</p>
      <p class="para W_fb">3.5.4 第三方账号所属平台或业务已关停的；</p>
      <p class="para W_fb">3.5.5 依据法律法规国家政策规定或主管部门要求的；</p>
      <p class="para W_fb">3.5.6 {{ appName }}运营方有合理理由认为需要解除绑定的。</p>
      <h2>4. 使用规则</h2>
      <p class="para">4.1 用户有权更改，删除账户休息 用户注册{{ appName
        }}账号，制作、发布、传播信息内容的，应当使用真实身份信息及个人资料，不得以虚假或冒用的居民身份信息、企业相关信息进行注册；若用户的个人资料有任何变动，用户应及时更新。未经相关权利人授权，用户不得以他人或其他组织机构名义注册{{
          appName }}账号，亦不得使用引人误解的信息注册{{ appName }}账号，包括但不限于让人误认为该账号与其他个人或机构组织存在关联关系的名称、头像或简介等。
      </p>

      <p class="para">4.4 {{ appName }}运营方将建立健全用户信息安全管理制度、落实技术安全防控措施。{{ appName }}运营方将对用户使用{{ appName
        }}服务过程中涉及的用户隐私内容加以保护。</p>
      <p class="para W_fb">
        对于用户在{{ appName }}中发表或存储的{{ appName }}内容，{{ appName }}运营方建议用户自行不定期备份。用户理解并同意，如用户通过使用注销账号功能而主动停止使用{{
          appName }}服务或{{ appName }}服务被终止或取消的，{{ appName }}运营方无法向用户返还或提供任何数据。
      </p>

      <h2>5. 知识产权</h2>
      <p class="para">5.1 {{ appName }}运营方是{{ appName }}平台和{{ appName }}产品的所有权及知识产权权利人。</p>
      <p class="para">5.2 上述{{ appName }}产品指的是{{ appName }}运营方、{{ appName }}运营方关联公司、或其授权主体等通过{{ appName
        }}平台为用户提供的包括但不限于信息发布分享、关系链拓展、便捷辅助工具、平台应用程序、公众开放平台等功能、软件、服务等。
      </p>
      <p class="para">5.3 {{ appName }}运营方是{{ appName }}平台及{{ appName
        }}产品中所有信息内容的所有权及知识产权权利人。前述信息内容包括但不限于程序代码、界面设计、版面框架、数据资料、账号、文字、图片、图形、图表、音频、视频等，除按照法律法规规定应由相关权利人享有权利的内容以外。
      </p>
      <p class="para">5.4 用户在使用{{ appName }}平台的过程中，可能会使用到由第三方开发的在{{ appName
        }}平台运行的功能、软件或服务，用户除遵守本协议相关规定以外，还应遵守第三方相关规定，并尊重第三方权利人对其功能、软件、服务及其所包含内容的相关权利。
      </p>
      <p class="para">5.5 鉴于以上，用户理解并同意：</p>
      <p class="para">5.5.1 未经{{ appName }}运营方及相关权利人同意，用户不得对上述功能、软件、服务进行反向工程 （reverse
        engineer）、反向编译（decompile）或反汇编（disassemble）等；同时，不得将上述内容或资料在任何媒体直接或间接发布、播放、出于播放或发布目的而改写或再发行，或者用于其他任何目的；
      </p>
      <p class="para">5.5.2
        在尽商业上的合理努力的前提下，{{ appName }}运营方并不就上述功能、软件、服务及其所包含内容的延误、不准确、错误、遗漏或由此产生的任何损害，以任何形式向用户或任何第三方承担任何责任；
      </p>
      <p class="para">5.5.3
        {{ appName }}运营方并不对上述任何由第三方提供的功能、软件、服务或内容进行任何保证性的、或连带性的承诺或担保，由此产生的任何纠纷、争议或损害，由用户与第三方自行解决，{{ appName
        }}运营方不承担任何责任；
      </p>
      <p class="para">5.5.4
        为更好地维护{{ appName }}生态，{{ appName }}运营方保留在任何时间内以任何方式处置上述由{{ appName
        }}运营方享受所有权及知识产权的产品或内容，包括但不限于修订、屏蔽、删除或其他任何法律法规允许的处置方式。
      </p>
      <h2>6. 隐私保护</h2>
      <p class="para W_fb">6.1 保护用户隐私和其他个人信息是{{ appName }}的一项基本政策，具体内容详见{{ appName }}个人信息相关保护政策。</p>

      <h2>7. 免责声明</h2>
      <p class="para W_fb">7.1 用户在使用{{ appName }}服务的过程中应遵守国家法律法规及政策规定，因其使用{{ appName }}服务而产生的行为后果由用户自行承担。</p>

      <p class="para W_fb">7.3 {{ appName
        }}运营方提供的服务只针对用户个人视频进行内容创作，不涉及任何平台利益，使用的服务效果每个人不一样，不给予用户任何保障性承诺，只提供用户个人视频的内容多样化创作与制作。
      </p>
      <p class="para W_fb">7.4 对于因不可抗力或{{ appName }}运营方不能控制的原因造成的{{ appName }}服务中断或其它缺陷，{{ appName
        }}运营方不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。
      </p>
      <p class="para W_fb">7.5 {{ appName }}运营方对其向用户所提供的{{ appName }}产品及服务依法承担相关责任，但法律另有规定或另有约定的除外。</p>
      <p class="para W_fb">7.6 用户知悉并同意，{{ appName
        }}运营方可能会与第三方合作向用户提供产品（包括但不限于游戏、第三方应用等）并由第三方向用户提供该产品的升级、维护、客服等后续工作，由该等第三方对该产品的质量问题或其本身的原因导致的一切纠纷或用户损失承担责任，用户在此同意将向该第三方主张与此有关的一切权利和损失。
      </p>
      <p class="para W_fb">7.7 除另有约定外，{{ appName
        }}运营方提供的产品或服务（包括但不限于游戏物品及道具），如未标明使用期限、或者其标明的使用期限为"永久"、"无限期"或"无限制"的，则其使用期限为自用户开始使用该产品或服务至该产品或服务在{{ appName
        }}下线之日为止。
      </p>

      <h2>10. 通知送达</h2>
      <p class="para">10.1 本协议项下{{ appName }}运营方对于用户所有的通知均可通过网页公告、电子邮件、系统通知、{{ appName
        }}管理账号主动联系、私信、手机短信或常规的信件传送等方式进行；该等通知于发送之日视为已送达收件人。
      </p>
      <p class="para">10.2 用户对于{{ appName }}运营方的通知应当通过{{ appName }}运营方对外正式公布的通信地址、传真号码、电子邮件地址等联系信息进行送达。</p>
      <h2>11. 法律适用</h2>
      <p class="para W_fb">11.1 本协议的订立、执行和解释及争议的解决均应适用中华人民共和国大陆地区法律。</p>
      <p class="para W_fb">11.2 如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向山西省高级人民法院提起诉讼。</p>
      <h2>12. 其他规定</h2>
      <p class="para">12.1 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。</p>
      <p class="para">12.2 本协议中的标题仅为方便而设，在解释本协议时应被忽略，不能作为本协议条款解释的依据。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserAgreement',
  data() {
    return {
      appName: this.$siteConfig.siteName, // 使用配置文件中的网站名称
      companyName: this.$siteConfig.companyName // 使用配置文件中的公司名称
    };
  },
  mounted() {
    // 从URL参数中获取appName，如果没有则使用配置文件中的默认值
    const paramAppName = this.$route.query.appname;
    if (paramAppName && typeof paramAppName === 'string') {
      this.appName = paramAppName;
    }

    // companyname 为空时使用 appname，便于同一页面适配不同应用
    const paramCompanyName = this.$route.query.companyname;
    if (typeof paramCompanyName === 'string' && paramCompanyName.trim()) {
      this.companyName = paramCompanyName.trim();
    } else {
      this.companyName = this.appName;
    }

    // 更新页面标题
    document.title = `《${this.appName}服务使用协议》`;

    // 更新meta标签
    const descriptionMeta = document.querySelector('meta[name="description"]');
    if (descriptionMeta) {
      descriptionMeta.setAttribute('content', `${this.appName}服务使用协议，详细说明用户使用${this.appName}服务的权利和义务。`);
    }

    const keywordsMeta = document.querySelector('meta[name="keywords"]');
    if (keywordsMeta) {
      keywordsMeta.setAttribute('content', `${this.appName},服务协议,用户协议,使用条款`);
    }

    // 设置页面icon
    const iconLink = document.querySelector('link[rel="shortcut icon"]') || document.createElement('link');
    iconLink.setAttribute('rel', 'shortcut icon');
    iconLink.setAttribute('type', 'image/x-icon');
    iconLink.setAttribute('href', this.$siteConfig.faviconPath);
    if (!document.querySelector('link[rel="shortcut icon"]')) {
      document.head.appendChild(iconLink);
    }
  }
};
</script>

<style scoped>
.yszc-container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  color: #333;
}

.header {
  margin-bottom: 30px;
}

.content {
  line-height: 1.8;
}

.content h2 {
  font-size: 22px;
  margin: 25px 0 15px;
  padding-bottom: 5px;
  border-bottom: 1px solid #eee;
  color: #222;
}

.content h3 {
  font-size: 18px;
  margin: 20px 0 10px;
  color: #444;
}

.content p {
  margin: 15px 0;
  text-indent: 2em;
}

.content .W_fb {
  font-weight: 600;
}

/* 原HTML中的样式 */
#_copy {
  align-items: center;
  background: #4494d5;
  border-radius: 3px;
  color: #fff;
  cursor: pointer;
  display: flex;
  font-size: 13px;
  height: 30px;
  justify-content: center;
  position: absolute;
  width: 60px;
  z-index: 1000;
}

#select-tooltip,
#sfModal,
.modal-backdrop,
div[id^=reader-helper] {
  display: none !important;
}

.modal-open {
  overflow: auto !important;
}

._sf_adjust_body {
  padding-right: 0 !important;
}

.super_copy_btns_div {
  position: fixed;
  width: 154px;
  left: 10px;
  top: 45%;
  background: #e7f1ff;
  border: 2px solid #4595d5;
  font-weight: 600;
  border-radius: 2px;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
  z-index: 5000;
}

.super_copy_btns_logo {
  width: 100%;
  background: #4595d5;
  text-align: center;
  font-size: 12px;
  color: #e7f1ff;
  line-height: 30px;
  height: 30px;
}

.super_copy_btns_btn {
  display: block;
  width: 128px;
  height: 28px;
  background: #7f5711;
  border-radius: 4px;
  color: #fff;
  font-size: 12px;
  border: 0;
  outline: 0;
  margin: 8px auto;
  font-weight: 700;
  cursor: pointer;
  opacity: .9;
}

.super_copy_btns_btn:hover {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/service/user_service.vue